export default "__VITE_ASSET__6252142a__"